import { defineMessages } from 'react-intl';

export default defineMessages({
  minValue: {
    id: 'general.datable.filterRange.minValue',
    defaultMessage: 'Min',
  },
  maxValue: {
    id: 'general.datable.filterRange.maxValue',
    defaultMessage: 'Max',
  },
});
